/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { CurrencyCode } from "./CurrencyCode";
import {
  CurrencyCodeFromJSON,
  CurrencyCodeFromJSONTyped,
  CurrencyCodeToJSON,
  CurrencyCodeToJSONTyped,
} from "./CurrencyCode";
import type { ConversationTurn } from "./ConversationTurn";
import {
  ConversationTurnFromJSON,
  ConversationTurnFromJSONTyped,
  ConversationTurnToJSON,
  ConversationTurnToJSONTyped,
} from "./ConversationTurn";
import type { FreightClaimLineItem } from "./FreightClaimLineItem";
import {
  FreightClaimLineItemFromJSON,
  FreightClaimLineItemFromJSONTyped,
  FreightClaimLineItemToJSON,
  FreightClaimLineItemToJSONTyped,
} from "./FreightClaimLineItem";
import type { FreightClaimPaymentSource } from "./FreightClaimPaymentSource";
import {
  FreightClaimPaymentSourceFromJSON,
  FreightClaimPaymentSourceFromJSONTyped,
  FreightClaimPaymentSourceToJSON,
  FreightClaimPaymentSourceToJSONTyped,
} from "./FreightClaimPaymentSource";
import type { FreightClaimState } from "./FreightClaimState";
import {
  FreightClaimStateFromJSON,
  FreightClaimStateFromJSONTyped,
  FreightClaimStateToJSON,
  FreightClaimStateToJSONTyped,
} from "./FreightClaimState";
import type { ActivityReadModel } from "./ActivityReadModel";
import {
  ActivityReadModelFromJSON,
  ActivityReadModelFromJSONTyped,
  ActivityReadModelToJSON,
  ActivityReadModelToJSONTyped,
} from "./ActivityReadModel";

/**
 *
 * @export
 * @interface FreightClaimReadModel
 */
export interface FreightClaimReadModel {
  /**
   *
   * @type {string}
   * @memberof FreightClaimReadModel
   */
  freightClaimId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof FreightClaimReadModel
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof FreightClaimReadModel
   */
  shipmentId?: string;
  /**
   *
   * @type {string}
   * @memberof FreightClaimReadModel
   */
  companyId?: string;
  /**
   *
   * @type {FreightClaimState}
   * @memberof FreightClaimReadModel
   */
  freightClaimState?: FreightClaimState;
  /**
   *
   * @type {string}
   * @memberof FreightClaimReadModel
   */
  carrierIdentifier?: string;
  /**
   *
   * @type {string}
   * @memberof FreightClaimReadModel
   */
  proNumber?: string;
  /**
   *
   * @type {Array<FreightClaimLineItem>}
   * @memberof FreightClaimReadModel
   */
  freightClaimLineItems?: Array<FreightClaimLineItem>;
  /**
   *
   * @type {string}
   * @memberof FreightClaimReadModel
   */
  claimDescription?: string;
  /**
   *
   * @type {string}
   * @memberof FreightClaimReadModel
   */
  claimInternalNotes?: string;
  /**
   *
   * @type {CurrencyCode}
   * @memberof FreightClaimReadModel
   */
  claimCurrency?: CurrencyCode;
  /**
   *
   * @type {Array<string>}
   * @memberof FreightClaimReadModel
   */
  originalInvoiceFiles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof FreightClaimReadModel
   */
  photoFiles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof FreightClaimReadModel
   */
  otherDocumentFiles?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof FreightClaimReadModel
   */
  assignee?: string;
  /**
   *
   * @type {string}
   * @memberof FreightClaimReadModel
   */
  carrierFrontConversationId?: string;
  /**
   *
   * @type {ConversationTurn}
   * @memberof FreightClaimReadModel
   */
  carrierConversationTurn?: ConversationTurn;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof FreightClaimReadModel
   */
  carrierConversationTurnTime?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof FreightClaimReadModel
   */
  customerFrontConversationId?: string;
  /**
   *
   * @type {ConversationTurn}
   * @memberof FreightClaimReadModel
   */
  customerConversationTurn?: ConversationTurn;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof FreightClaimReadModel
   */
  customerConversationTurnTime?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof FreightClaimReadModel
   */
  insuranceFrontConversationId?: string;
  /**
   *
   * @type {ConversationTurn}
   * @memberof FreightClaimReadModel
   */
  insuranceConversationTurn?: ConversationTurn;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof FreightClaimReadModel
   */
  insuranceConversationTurnTime?: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof FreightClaimReadModel
   */
  snoozedUntil?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof FreightClaimReadModel
   */
  snoozeReason?: string;
  /**
   *
   * @type {string}
   * @memberof FreightClaimReadModel
   */
  carrierClaimNumber?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof FreightClaimReadModel
   */
  lastCarrierPingAt?: OffsetDateTime;
  /**
   *
   * @type {number}
   * @memberof FreightClaimReadModel
   */
  claimPaymentAmount?: number;
  /**
   *
   * @type {FreightClaimPaymentSource}
   * @memberof FreightClaimReadModel
   */
  claimPaymentSource?: FreightClaimPaymentSource;
  /**
   *
   * @type {string}
   * @memberof FreightClaimReadModel
   */
  claimPaymentReason?: string;
  /**
   *
   * @type {number}
   * @memberof FreightClaimReadModel
   */
  claimPayoutAmount?: number;
  /**
   *
   * @type {CurrencyCode}
   * @memberof FreightClaimReadModel
   */
  claimPaymentCurrency?: CurrencyCode;
  /**
   *
   * @type {CurrencyCode}
   * @memberof FreightClaimReadModel
   */
  claimPayoutCurrency?: CurrencyCode;
  /**
   *
   * @type {number}
   * @memberof FreightClaimReadModel
   */
  claimInsuranceAmount?: number;
  /**
   *
   * @type {CurrencyCode}
   * @memberof FreightClaimReadModel
   */
  claimInsuranceCurrency?: CurrencyCode;
  /**
   *
   * @type {string}
   * @memberof FreightClaimReadModel
   */
  claimXeroInvoiceId?: string;
  /**
   *
   * @type {string}
   * @memberof FreightClaimReadModel
   */
  claimXeroBillId?: string;
  /**
   *
   * @type {number}
   * @memberof FreightClaimReadModel
   */
  claimXeroSequence?: number;
  /**
   *
   * @type {boolean}
   * @memberof FreightClaimReadModel
   */
  claimXeroStale?: boolean;
  /**
   *
   * @type {Array<ActivityReadModel>}
   * @memberof FreightClaimReadModel
   */
  activities: Array<ActivityReadModel>;
}

/**
 * Check if a given object implements the FreightClaimReadModel interface.
 */
export function instanceOfFreightClaimReadModel(
  value: object,
): value is FreightClaimReadModel {
  if (!("activities" in value) || value["activities"] === undefined)
    return false;
  return true;
}

export function FreightClaimReadModelFromJSON(
  json: any,
): FreightClaimReadModel {
  return FreightClaimReadModelFromJSONTyped(json, false);
}

export function FreightClaimReadModelFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): FreightClaimReadModel {
  if (json == null) {
    return json;
  }
  return {
    freightClaimId:
      json["freightClaimId"] == null ? undefined : json["freightClaimId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    shipmentId: json["shipmentId"] == null ? undefined : json["shipmentId"],
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    freightClaimState:
      json["freightClaimState"] == null
        ? undefined
        : FreightClaimStateFromJSON(json["freightClaimState"]),
    carrierIdentifier:
      json["carrierIdentifier"] == null ? undefined : json["carrierIdentifier"],
    proNumber: json["proNumber"] == null ? undefined : json["proNumber"],
    freightClaimLineItems:
      json["freightClaimLineItems"] == null
        ? undefined
        : (json["freightClaimLineItems"] as Array<any>).map(
            FreightClaimLineItemFromJSON,
          ),
    claimDescription:
      json["claimDescription"] == null ? undefined : json["claimDescription"],
    claimInternalNotes:
      json["claimInternalNotes"] == null
        ? undefined
        : json["claimInternalNotes"],
    claimCurrency:
      json["claimCurrency"] == null
        ? undefined
        : CurrencyCodeFromJSON(json["claimCurrency"]),
    originalInvoiceFiles:
      json["originalInvoiceFiles"] == null
        ? undefined
        : json["originalInvoiceFiles"],
    photoFiles: json["photoFiles"] == null ? undefined : json["photoFiles"],
    otherDocumentFiles:
      json["otherDocumentFiles"] == null
        ? undefined
        : json["otherDocumentFiles"],
    assignee: json["assignee"] == null ? undefined : json["assignee"],
    carrierFrontConversationId:
      json["carrierFrontConversationId"] == null
        ? undefined
        : json["carrierFrontConversationId"],
    carrierConversationTurn:
      json["carrierConversationTurn"] == null
        ? undefined
        : ConversationTurnFromJSON(json["carrierConversationTurn"]),
    carrierConversationTurnTime:
      json["carrierConversationTurnTime"] == null
        ? undefined
        : json["carrierConversationTurnTime"],
    customerFrontConversationId:
      json["customerFrontConversationId"] == null
        ? undefined
        : json["customerFrontConversationId"],
    customerConversationTurn:
      json["customerConversationTurn"] == null
        ? undefined
        : ConversationTurnFromJSON(json["customerConversationTurn"]),
    customerConversationTurnTime:
      json["customerConversationTurnTime"] == null
        ? undefined
        : json["customerConversationTurnTime"],
    insuranceFrontConversationId:
      json["insuranceFrontConversationId"] == null
        ? undefined
        : json["insuranceFrontConversationId"],
    insuranceConversationTurn:
      json["insuranceConversationTurn"] == null
        ? undefined
        : ConversationTurnFromJSON(json["insuranceConversationTurn"]),
    insuranceConversationTurnTime:
      json["insuranceConversationTurnTime"] == null
        ? undefined
        : json["insuranceConversationTurnTime"],
    snoozedUntil:
      json["snoozedUntil"] == null ? undefined : json["snoozedUntil"],
    snoozeReason:
      json["snoozeReason"] == null ? undefined : json["snoozeReason"],
    carrierClaimNumber:
      json["carrierClaimNumber"] == null
        ? undefined
        : json["carrierClaimNumber"],
    lastCarrierPingAt:
      json["lastCarrierPingAt"] == null ? undefined : json["lastCarrierPingAt"],
    claimPaymentAmount:
      json["claimPaymentAmount"] == null
        ? undefined
        : json["claimPaymentAmount"],
    claimPaymentSource:
      json["claimPaymentSource"] == null
        ? undefined
        : FreightClaimPaymentSourceFromJSON(json["claimPaymentSource"]),
    claimPaymentReason:
      json["claimPaymentReason"] == null
        ? undefined
        : json["claimPaymentReason"],
    claimPayoutAmount:
      json["claimPayoutAmount"] == null ? undefined : json["claimPayoutAmount"],
    claimPaymentCurrency:
      json["claimPaymentCurrency"] == null
        ? undefined
        : CurrencyCodeFromJSON(json["claimPaymentCurrency"]),
    claimPayoutCurrency:
      json["claimPayoutCurrency"] == null
        ? undefined
        : CurrencyCodeFromJSON(json["claimPayoutCurrency"]),
    claimInsuranceAmount:
      json["claimInsuranceAmount"] == null
        ? undefined
        : json["claimInsuranceAmount"],
    claimInsuranceCurrency:
      json["claimInsuranceCurrency"] == null
        ? undefined
        : CurrencyCodeFromJSON(json["claimInsuranceCurrency"]),
    claimXeroInvoiceId:
      json["claimXeroInvoiceId"] == null
        ? undefined
        : json["claimXeroInvoiceId"],
    claimXeroBillId:
      json["claimXeroBillId"] == null ? undefined : json["claimXeroBillId"],
    claimXeroSequence:
      json["claimXeroSequence"] == null ? undefined : json["claimXeroSequence"],
    claimXeroStale:
      json["claimXeroStale"] == null ? undefined : json["claimXeroStale"],
    activities: (json["activities"] as Array<any>).map(
      ActivityReadModelFromJSON,
    ),
  };
}

export function FreightClaimReadModelToJSON(json: any): FreightClaimReadModel {
  return FreightClaimReadModelToJSONTyped(json, false);
}

export function FreightClaimReadModelToJSONTyped(
  value?: FreightClaimReadModel | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    freightClaimId: value["freightClaimId"],
    createdAt: value["createdAt"],
    shipmentId: value["shipmentId"],
    companyId: value["companyId"],
    freightClaimState: FreightClaimStateToJSON(value["freightClaimState"]),
    carrierIdentifier: value["carrierIdentifier"],
    proNumber: value["proNumber"],
    freightClaimLineItems:
      value["freightClaimLineItems"] == null
        ? undefined
        : (value["freightClaimLineItems"] as Array<any>).map(
            FreightClaimLineItemToJSON,
          ),
    claimDescription: value["claimDescription"],
    claimInternalNotes: value["claimInternalNotes"],
    claimCurrency: CurrencyCodeToJSON(value["claimCurrency"]),
    originalInvoiceFiles: value["originalInvoiceFiles"],
    photoFiles: value["photoFiles"],
    otherDocumentFiles: value["otherDocumentFiles"],
    assignee: value["assignee"],
    carrierFrontConversationId: value["carrierFrontConversationId"],
    carrierConversationTurn: ConversationTurnToJSON(
      value["carrierConversationTurn"],
    ),
    carrierConversationTurnTime: value["carrierConversationTurnTime"],
    customerFrontConversationId: value["customerFrontConversationId"],
    customerConversationTurn: ConversationTurnToJSON(
      value["customerConversationTurn"],
    ),
    customerConversationTurnTime: value["customerConversationTurnTime"],
    insuranceFrontConversationId: value["insuranceFrontConversationId"],
    insuranceConversationTurn: ConversationTurnToJSON(
      value["insuranceConversationTurn"],
    ),
    insuranceConversationTurnTime: value["insuranceConversationTurnTime"],
    snoozedUntil: value["snoozedUntil"],
    snoozeReason: value["snoozeReason"],
    carrierClaimNumber: value["carrierClaimNumber"],
    lastCarrierPingAt: value["lastCarrierPingAt"],
    claimPaymentAmount: value["claimPaymentAmount"],
    claimPaymentSource: FreightClaimPaymentSourceToJSON(
      value["claimPaymentSource"],
    ),
    claimPaymentReason: value["claimPaymentReason"],
    claimPayoutAmount: value["claimPayoutAmount"],
    claimPaymentCurrency: CurrencyCodeToJSON(value["claimPaymentCurrency"]),
    claimPayoutCurrency: CurrencyCodeToJSON(value["claimPayoutCurrency"]),
    claimInsuranceAmount: value["claimInsuranceAmount"],
    claimInsuranceCurrency: CurrencyCodeToJSON(value["claimInsuranceCurrency"]),
    claimXeroInvoiceId: value["claimXeroInvoiceId"],
    claimXeroBillId: value["claimXeroBillId"],
    claimXeroSequence: value["claimXeroSequence"],
    claimXeroStale: value["claimXeroStale"],
    activities: (value["activities"] as Array<any>).map(
      ActivityReadModelToJSON,
    ),
  };
}
